import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: () => import('@/views/Home'),
    },
    {
      path: '/about',
      name: 'AboutPage',
      component: () => import('@/views/About'),
    },
    {
      path: '/games',
      name: 'GamesPage',
      component: () => import('@/views/Games'),
    },
    {
      path: '/privacy',
      name: 'PrivacyPage',
      component: () => import('@/views/Privacy'),
    },
    {
      path: '/terms',
      name: 'TermsPage',
      component: () => import('@/views/Terms'),
    },
    {
      path: '*',
      name: 'NotFound',
      component: () => import('@/views/NotFound'),
    }
  ]
})
router.afterEach(() => {
  Vue.nextTick(() => {
    window.scrollTo(0, 0);
  });
});
export default router;
